var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GeneralContainer',[_c('div',[_c('RequestSigninModal',{ref:"signinModal",attrs:{"next":_vm.next}}),_c('h1',[_vm._v("Your Sign-In link has expired")]),_c('button',{on:{"click":_vm.generateClick}},[_vm._v("\n\t\tGenerate New Link\n\t")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }